import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useApp } from '../contexts/AppContext';

const slideIn = keyframes`from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:translateY(0)}`;

const Wrap = styled.div`margin-bottom: 20px;`;

const Head = styled.div`margin-bottom: 14px;`;

const Title = styled.div`
  font-size: 16px; font-weight: 800; letter-spacing: -0.2px; color: var(--text-1);
`;

const Sub = styled.div`font-size: 12.5px; color: var(--text-4); margin-top: 2px;`;

const List = styled.div`
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: var(--shadow-s);
  overflow: hidden;
`;

const Item = styled.div`
  border-bottom: 1px solid var(--border-2);
  &:last-child { border-bottom: none; }
`;

const QRow = styled.button`
  width: 100%; display: flex; align-items: center; justify-content: space-between;
  gap: 12px; padding: 15px 18px; background: none; border: none; cursor: pointer;
  text-align: left; font-size: 13.5px; font-weight: 700; color: var(--text-1);
  &:hover { background: var(--surface-2); }
`;

const Chevron = styled.div`color: var(--text-5); flex-shrink: 0; display: flex;`;

const AnswerBox = styled.div`
  padding: 0 18px 16px; font-size: 12.5px; line-height: 1.6; color: var(--text-3);
  animation: ${slideIn} 0.2s ease;
`;

export default function FaqSection() {
  const { t } = useApp();
  const [openIdx, setOpenIdx] = useState(null);

  if (!t.faq || !t.faq.length) return null;

  return (
    <Wrap>
      <Head>
        <Title>{t.faqTitle}</Title>
        <Sub>{t.faqSub}</Sub>
      </Head>
      <List>
        {t.faq.map((item, i) => {
          const open = openIdx === i;
          return (
            <Item key={i}>
              <QRow onClick={() => setOpenIdx(open ? null : i)} aria-expanded={open}>
                <span>{item.q}</span>
                <Chevron>{open ? <ExpandLessIcon sx={{ fontSize: 18 }}/> : <ExpandMoreIcon sx={{ fontSize: 18 }}/>}</Chevron>
              </QRow>
              {open && <AnswerBox>{item.a}</AnswerBox>}
            </Item>
          );
        })}
      </List>
    </Wrap>
  );
}
